export const AAE_DEV_ONLY = 'aae_dev_only';
export const ACTION_SEGMENT_FILTERS = 'action_segment_filters';
export const BASIC_CAMPAIGN_COST_ESTIMATE = 'basic_campaign_cost_estimate';
export const BCC = 'brand_control_center';
export const BCCFAI = 'brand_control_center_file_ai_generated';
export const BILLING_SEGMENT_COUNTRY_COUNT = 'billing_segment_country_count';
export const BRAND_CENTER_2_0 = 'brand_center_2_0';
export const BRAND_CENTER_2_0_STORY_AND_VALUES =
  'brand_center_2_0_story_and_values';
export const BRAND_CENTER_2_0_SUBSCRIBER_INSIGHTS =
  'brand_center_2_0_subscriber_insights';
export const BRAND_GUIDELINES_PLAYGROUND = 'brand_guidelines_playground';
export const BULK_PROPERTY_UPLOAD_SELF_SERVE =
  'bulk_property_upload_self_serve';
export const CAMPAIGN_SEGMENTS = 'campaign_segments';
export const CARRIER_SEGMENTS_ENABLED = 'carrier_segments';
export const CASL_DISCLOSURE = 'casl_disclosure';
export const COMPLIANCE_AI_ELIGIBILITY_IN_APP =
  'compliance_ai_eligibility_in_app';
export const COMPLIANCE_BUSINESS_LINKS = 'compliance_business_links';
export const COMPLIANCE_BUSINESS_LINKS_OPT_OUT =
  'compliance_business_links_opt_out';
export const COMPLIANCE_ENABLE_ON_THREAD_OPT_IN =
  'compliance_enable_on_thread_opt_in';
export const CONVERT = 'convert';
export const CONVERSATION_VIEW_ENABLED = 'conversation_view_enabled';
export const CORDIAL_INTEGRATION = 'cordial_integration';
export const COUPON_PREFIXES = 'coupon_prefixes';
export const DARK_MODE = 'dark_mode';
export const DATA_LABS = 'data_labs';
export const DELETE_CUSTOM_FONTS = 'delete_custom_fonts';
export const DELIVERABILITY_STATS = 'deliverability_stats';
export const DROPDOWN_BLOCK = 'dropdown_block';
export const DYNAMIC_TERMS = 'dynamic_terms';
// Gates the email block builder UI: the /email-templates editor, the Email tab
// in admin Templates, and the template-picker variant of the flow Email action.
export const EMAIL_BLOCK_BUILDER = 'email_block_builder';
export const EMAIL_FLOW_ACTION_ENABLED = 'email_flow_action_enabled';
export const EMAIL_SETTINGS_PAGE = 'email_settings_page';
export const ENTITLEMENTS_BRAND_CENTER = 'entitlements_brand_center';
export const EXEMPT_FROM_SHOP_TOS_GATE =
  'exempt_shop_from_terms_of_service_gate';
export const GEO_FENCED_INVENTORY = 'geo_fenced_inventory';
export const FLOW_BUILDER_TRANSACTIONAL_AUTOMATIONS =
  'flow_builder_transactional_automations';
export const FB_ASYNC_CAMPAIGN_SUBSCRIBER_COUNT =
  'fb_async_campaign_subscriber_count';
export const FB_BASIC_CAMPAIGNS = 'fb_basic_campaigns';
// Deprecation lever: freezes the legacy popups experience read-only. Set per shop by the
// block popup cutover, then released globally once the migration is done.
export const LEGACY_POPUPS_READ_ONLY = 'legacy_popups_read_only';
// Deprecation lever: freezes the legacy automations experience read-only.
export const LEGACY_AUTOMATIONS_READ_ONLY = 'legacy_automations_read_only';
export const ITC_UPSELL_MODAL_EXPERIMENT = 'itc_upsell_modal_experiment';
export const FB_BIS_FLOW_AUTOMATION = 'bis_flow_automation';
export const FB_DATE_TRIGGERED_AUTOMATIONS = 'fb_date_triggered_automations';
export const FB_DISCOUNT_RULES = 'fb_discount_rules';
export const FB_ENHANCED_LINK_TRACKING = 'fb_enhanced_link_tracking';
export const FB_HIDE_SEGMENT_COUNT_IN_CAMPAIGN_PROPS =
  'fb_hide_segment_count_in_campaign_props';
export const FB_FILE_UPLOAD_OPTIMIZATION = 'fb_file_upload_optimization';
export const FB_LOW_INVENTORY_AUTOMATIONS = 'fb_low_inventory';
export const FB_MULTI_SEGMENT_CAMPAIGNS = 'fb_multi_segment_campaigns';
export const FB_OPTIMIZED_AB_SPLIT_ACTION = 'fb_optimized_ab_split_action';
export const FB_CONSENT_VERIFICATION = 'fb_consent_verification';
export const FB_COPY_ONLY_VERSIONING = 'fb_copy_only_versioning';
export const FB_PRICE_DROP_AUTOMATIONS = 'fb_price_drop_automations';
export const FB_RANDOM_WAIT_ACTION_CATEGORY = 'fb_random_wait_action_category';
export const FB_FLOW_ACTION_TITLES = 'flow_action_titles';
export const FB_RCS_CALENDAR_EVENT = 'fb_rcs_calendar_event';
export const FB_RCS_WEBVIEW = 'fb_rcs_webview';
export const FB_RCS_VIDEO_UPLOAD = 'fb_rcs_video_upload';
export const FB_RECOMMENDED_SEND_TIME = 'fb_recommended_send_time';
export const FB_SCHEDULE_AUTOMATION_DEACTIVATION =
  'fb_schedule_automation_deactivation';
export const FB_SUBSCRIBER_RETENTION = 'fb_subscriber_retention';
export const FB_WAIT_SUBSCRIBER_TZ = 'fb_wait_subscriber_tz';
export const FB_WAIT_SUBSCRIBER_TZ_NEXT = 'fb_wait_subscriber_tz_next'; // Merge with above flag when ready
export const GORGIAS_V2 = 'gorgias_v2';
export const INVOICE_CHARGE_BREAKDOWN_REPORT =
  'invoice_charge_breakdown_report';
export const ITERABLE_INTEGRATION = 'iterable_integration';
export const KLAVIYO_OAUTH = 'klaviyo_oauth';
export const LANDING_PAGE_PIXEL_EVENTS = 'landing_page_pixel_events';
export const LISTRAK_INTEGRATION = 'listrak_integration';
export const LOCALIZED_CONSENT_LANGUAGE = 'localized_consent_language';
export const MAILCHIMP_INTEGRATION = 'mailchimp_integration';
export const MANUAL_ROUTE_TO_EMAIL = 'manual_route_to_email';
export const MULTI_SELECT_BLOCK = 'multi_select_block';
export const OMNISEND_INTEGRATION = 'omnisend_integration';
export const OMETRIA_INTEGRATION = 'ometria_integration';
export const OMNI_SANDBOX = 'omni_sandbox';
export const OMNI_TRENDS = 'omni_trends';
export const OOI_USE_TWILIO_VERIFY = 'ooi_use_twilio_verify';
export const OPT_IN_SOURCE_ANALYTICS_REFRESH =
  'opt_in_source_analytics_refresh';
export const POPUP_BLOCK_SMS_COMPLIANCE_LANGUAGE_LAYOUT =
  'popup_block_sms_compliance_language_layout';
export const POPUP_DATE_BLOCK_FORMATS = 'popup_date_block_formats';
export const POPUP_DOUBLE_OPT_IN_OPTION = 'popup_double_opt_in_option';
export const POPUP_FREE_IMAGE_POSITION = 'popup_free_image_position';
export const POPUP_IMAGE_BUTTONS = 'popup_image_buttons';
export const POPUP_IMAGE_CROP = 'popup_image_crop';
export const POPUP_INCREASE_AB_TEST_LIMIT = 'popup_increase_ab_test_limit';
export const POPUP_IMAGE_FOCAL_POINT = 'popup_image_focal_point';
export const POPUP_IMAGE_HOVER_STATE = 'popup_image_hover_state';
export const POPUP_INFINITY_TESTING = 'popup_infinity_testing';
export const POPUP_MIGRATION_LEGACY_TO_BLOCK =
  'popup_migration_legacy_to_block';
export const POPUP_LINK_CLICK_OPT_IN = 'popup_link_click_opt_in';
export const POPUP_OOIE = 'popup_ooitm';
export const POPUP_OVERLAY_BACKGROUND = 'popup_overlay_background';
export const POPUP_GIMME = 'popup_psn';
export const POPUP_MIGRATE_TO_ACORN = 'popup_migrate_to_acorn';
export const POPUP_MIGRATE_TO_OPT_IN_NETWORK =
  'popup_migrate_to_opt_in_network';
export const POPUP_QR_BLOCK = 'popup_qr_block';
export const POPUP_SINGLE_OPT_IN = 'allow_acquisition_single_opt_in';
export const POPUP_SPLIT_TEST = 'popup_split_test';
export const POPUP_SUBSCRIBER_AGE_VERIFICATION =
  'popup_subscriber_age_verification';
export const POPUP_TWO_TOUCH_OPT_IN_OPTION =
  'popup_two_touch_option_but_for_realsies_maybe';
export const PRODUCT_CATALOG_METAFIELDS = 'product_catalog_metafields';
export const PRODUCT_CATALOG_SMART_LOCATION_INVENTORY =
  'product_catalog_smart_location_inventory';
export const PS_LABS = 'ps_labs';
export const PS_PAY = 'pspay';
export const RADIO_BUTTON_BLOCK = 'radio_button_block';
export const RBAC_ROLES = 'RBAC_ROLES';
export const RCS = 'rcs';
export const RCS_SENDER_APPLICATION = 'rcs_sender_application';
export const RCS_SENDER_LAUNCH_REQUESTS = 'rcs_sender_launch_requests';
export const REDSHIFT_SEGMENTS = 'redshift_segments';
export const SEGMENT_FILTER_EVER_VIEWED_PRODUCT =
  'segment_filter_ever_viewed_product';
export const SEGMENT_FILTER_NUMBER_OF_MESSAGES_SENT_WITHIN_PERIOD =
  'segment_filter_number_of_messages_sent_within_period';
export const SELF_MIGRATE_TO_USAGE_BILLING = 'self_migrate_to_usage_billing';
export const SHOPPER_GTM_PREVIEW = 'shopper_gtm_preview';
export const SHOPPER_ELIGIBLE_FOR_SELF_SERVE =
  'eligible_for_shopper_self_serve';
export const SHOW_CASHBACK_PAGES = 'show_cashback_pages';
export const SLTV_DASHBOARD_DISABLED = 'sltv_dashboard_disabled';
export const SMS_SALES_CONVERSATIONS = 'sms_sales_conversations';
export const SMS_SALES_NAV = 'sms_sales_nav';
export const SSAI = 'ssai';
export const SUBSCRIBER_ANALYTICS_ENABLED = 'subscriber-analytics';
export const SUPPRESS_WELCOME_MESSAGE = 'suppress_welcome_message';
export const TEXT_TO_BUY_VARIANTS = 'text_to_buy_variants';
export const TRANSACTIONAL_MESSAGES_ENABLED = 'transactional_messages_enabled';
export const USAGE_BILLING_ENABLED = 'usage_billing';
export const USAGE_BILLING_L30_REPORT = 'billing_usage_report';
export const USER_NOTIFICATION_PREFERENCES = 'user_notification_preferences';
export const USE_KLAVIYO_EVENTS_V2 = 'use_klaviyo_events_v2';
export const VERIFICATION_SOURCES_TABLE = 'verification_sources_table';
export const VIBES_ONBOARDING = 'vibes_onboarding';
export const YOTPO_LOYALTY_V2 = 'yotpo_loyalty_v2';
export const ZERO_VIEW_ATTRIBUTION = 'zero_view_attribution';
export const FONDUE_CASHBACK_RETARGETING = 'fondue_cashback_retargeting';
export const SHOPPER_ASK_AI_ENABLED = 'shopper_ask_ai_enabled';
export const SHOPPER_AI_SEGMENTED_OFFERS_ENABLED =
  'shopper_ai_segmented_offers_enabled';
export const SHOPPER_AI_FULL_DISCOUNT_RULES_ENABLED =
  'shopper_ai_full_discount_rules_enabled';
export const SHOPPER_EXCLUSIONS_IN_PRODUCT_CATALOG =
  'shopper_exclusions_in_product_catalog';
export const SHOPPER_2_ONBOARDING = 'shopper_2_onboarding';
export const OFFER_SCANNER_ENABLED = 'offer_scanner_enabled';
export const SHOPPER_RESPONSES_RCS_GENERATION_ENABLED =
  'shopper_responses_rcs_generation_enabled';
export const SHOPPER_CAMPAIGNS_SDPOC = 'shopper_campaigns_sdpoc';
export const NAV_UPDATES_SHOPPER = 'nav_updates_shopper';
export const SHOPPER_AUTOMATIONS_LAUNCH_UI = 'shopper-automations-launch-ui';
export const SHOPPER_DEACTIVATION_FEEDBACK = 'shopper-deactivation-feedback';
export const SHOPPER_CAMPAIGNS_POC_SUBSCRIBER_EXPORT =
  'shopper_campaigns_poc_subscriber_export';
export const AI_BUNDLE_CUSTOM_PLAN_ENABLED = 'ai_bundle_custom_plan_enabled';
export const USER_SHOPPER_PLAYGROUND_ENABLED =
  'user_shopper_playground_enabled';
export const CENTRALIZED_OFFERS_VIEW = 'centralized_offers_view';
export const OFFERS_SHOPIFY_IMPORT = 'offers_shopify_import';
export const GLOBAL_OFFERS_CREATE_MODAL = 'global_offers_create_modal';
export const OFFERS_STATIC_DISCOUNT_CODES = 'offers_static_discount_codes';
export const CAMPAIGN_STATIC_OFFERS = 'campaign_static_offers';
export const FF_UNIFIED_CK_ENDPOINTS = 'ff_unified_ck_endpoints';
export const FF_IT_MESSAGE_FEEDBACK = 'ff_it_message_feedback';

// Hides the app embed / ScriptTag deprecation banner for a shop (e.g. headless storefronts).
export const HIDE_SDK_EMBED_BANNER = 'hide_sdk_embed_banner';

const featureFlags = [
  {
    label: 'Analytics',
    value: SUBSCRIBER_ANALYTICS_ENABLED,
  },
  {
    label: 'Usage Billing',
    value: USAGE_BILLING_ENABLED,
    disabled: true,
  },
  {
    label: 'Enable dark mode beta option',
    value: DARK_MODE,
  },
  {
    label: '(Legal Only) Exempt Shop from Terms of Service Gate',
    value: EXEMPT_FROM_SHOP_TOS_GATE,
  },
  {
    label: 'Postscript hosts dynamic Terms of Service and Privacy Policy pages',
    value: DYNAMIC_TERMS,
  },
  {
    label: 'Transactional Messages',
    value: TRANSACTIONAL_MESSAGES_ENABLED,
  },
  {
    label: 'Postscript Labs',
    value: PS_LABS,
  },
  {
    label: 'AI Bundle Custom Plan',
    value: AI_BUNDLE_CUSTOM_PLAN_ENABLED,
  },
  {
    label: 'Vibes Onboarding',
    value: VIBES_ONBOARDING,
  },
];

export default featureFlags;
